module.exports = __webpack_public_path__ + "media/images/landing/our_clients_bg-99cee9d9e9e6ed4ed9dc3e536b848287.jpg";